<div class="language-selector" [class.visible]="isVisible">
  <div class="language-selector__list">
    @for (lang of languages; track lang) {
      <button
        [class.active]="currentLanguage === lang.code"
        (click)="selectLanguage(lang.code)">
        <span class="language-selector__label">{{ lang.label }}</span>
      </button>
    }
  </div>
</div>
